/**
 * OriginTable - Tabela de origens usando DataTable genérico
 * Princípios: DRY (reutiliza DataTable), SRP (apenas configuração de colunas)
 */
import React, { useMemo } from 'react';
import { Origin } from '../../../../types';
import DataTable, { Column } from '../../../../components/shared/DataTable';
import ActionMenu, { createEditAction, createDeleteAction, createDuplicateAction } from '../../../../components/shared/ActionMenu';

interface OriginTableProps {
    origins: Origin[];
    isLoading?: boolean;
    onEdit: (origin: Origin) => void;
    onDelete: (origin: Origin) => void;
    onDuplicate: (origin: Origin) => void;
    selectedIds?: Set<string>;
    onToggleSelection?: (id: string) => void;
    onToggleAll?: () => void;
}

const OriginTable: React.FC<OriginTableProps> = ({
    origins, isLoading, onEdit, onDelete, onDuplicate,
    selectedIds = new Set(), onToggleSelection, onToggleAll
}) => {
    const columns: Column<Origin>[] = useMemo(() => [
        {
            key: 'name', header: 'Nome',
            render: (origin) => <span className="font-medium text-default">{origin.name}</span>
        },
        {
            key: 'actions', header: 'Ações', align: 'right',
            render: (origin) => (
                <ActionMenu actions={[
                    createEditAction(() => onEdit(origin)),
                    createDuplicateAction(() => onDuplicate(origin)),
                    createDeleteAction(() => onDelete(origin))
                ]} />
            )
        }
    ], [onEdit, onDuplicate, onDelete]);

    return (
        <DataTable
            columns={columns}
            data={origins}
            getRowKey={(o) => o.id}
            emptyMessage="Nenhuma origem encontrada."
            isLoading={isLoading}
            selectable
            selectedIds={selectedIds}
            onToggleSelection={onToggleSelection}
            onToggleAll={onToggleAll}
        />
    );
};

export default OriginTable;
